export default "__VITE_ASSET__BdJRQPqi__"